export interface MachineScriptPolicy {
    RunType: MachineScriptPolicyRunType;
    ScriptBody: string;
}

export enum MachineScriptPolicyRunType {
    InheritFromDefault = "InheritFromDefault",
    Inline = "Inline",
    OnlyConnectivity = "OnlyConnectivity",
}

export default MachineScriptPolicy;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/machineScriptPolicy.ts